import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type PrazoAction = 'ai' | 'append' | 'remove' | 'cancel';

@Component({
  selector: 'app-staff-plan-prazo-dialog',
  templateUrl: './staff-plan-prazo-dialog.component.html',
  styleUrls: ['./staff-plan-prazo-dialog.component.scss'],
})
export class StaffPlanPrazoDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<StaffPlanPrazoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      titulo: string;
      mensagem: string;
      delta: number; // +X ou -X
    },
  ) {}

  escolher(action: PrazoAction) {
    this.dialogRef.close(action);
  }
}
